var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allowForward)?_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.onForward()}}},[_c('i',{staticClass:"el-icon-document-copy"}),_c('span',{staticClass:"u-copy-text__pc"},[_vm._v(" 复制党+1 ")]),_c('span',{staticClass:"u-copy-text__phone"},[_vm._v("  "),_c('strong',[_vm._v("+1")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }